export const methodsList = {
    test: class {
        test() {
            alert("test function")
        }
    }
}
